import { ActionCard } from "@/web/routes/_protected/smb/-dashboard/-ActionCard";
import { CardRulesEngine } from "@/web/routes/_protected/smb/-dashboard/-CardRulesEngine";
import type {
  SmbActionCoreProps,
  SmbActionDefinition,
} from "@/web/routes/_protected/smb/-dashboard/-types";

function UnderwritingUnavailableAction({ onSkip }: SmbActionCoreProps) {
  return (
    <ActionCard category="budget">
      <ActionCard.Header>
        <ActionCard.Badge>Budget</ActionCard.Badge>
      </ActionCard.Header>
      <ActionCard.Main>
        <ActionCard.Title>We ran into issues running your underwriting</ActionCard.Title>
        <ActionCard.Description>
          Something went wrong while generating your underwriting questionnaire. Contact us at{" "}
          <a href="mailto:support@with.co" className="underline underline-offset-2">
            support@with.co
          </a>
          .
        </ActionCard.Description>
      </ActionCard.Main>
      <ActionCard.Footer>
        <ActionCard.SkipButton onSkip={onSkip} />
        <ActionCard.PrimaryButton onClick={() => window.location.assign("mailto:support@with.co")}>
          Contact support
        </ActionCard.PrimaryButton>
      </ActionCard.Footer>
    </ActionCard>
  );
}

export function createUnderwritingUnavailableAction(
  props: { id?: string } = {},
): SmbActionDefinition {
  const { id = "underwriting-unavailable" } = props;
  return {
    id,
    category: "budget",
    canSkip: true,
    render: (core) => <UnderwritingUnavailableAction {...core} />,
  };
}

export const underwritingUnavailableRule = CardRulesEngine.singletonRule({
  id: "underwriting-unavailable",
  priority: 90,
  when: CardRulesEngine.underwritingResultsUnavailable,
  build: () => createUnderwritingUnavailableAction(),
});
